var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.clickable ? 'dropzone-clickable' : ''],on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._m(0)]}),_vm._v(" "),_c('div',{staticClass:"dz-message"})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropzone-box"},[_c('p',[_vm._v("Drop files here to upload")])])
}]

export { render, staticRenderFns }